import { objectOf, arrayOf, maybe, recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCalculatedAttributeEngagement = objectOf({ id: string, name: maybe(string, true), status: string });

export const isCalculatedAttributeEngagements = objectOf({
  segments: arrayOf(isCalculatedAttributeEngagement),
  campaigns: arrayOf(isCalculatedAttributeEngagement),
  canvases: arrayOf(isCalculatedAttributeEngagement),
});

export const isPostApiCalculatedAttributesAppGroupIdDeactivateResult = objectOf({
  success_ids: arrayOf(string),
  error_ids: arrayOf(string),
  error_id_to_reason: recordOf<Record<string, string>>(string),
  error_id_to_code: maybe(recordOf<Record<string, string>>(string)),
  error_id_to_engagements: maybe(recordOf(isCalculatedAttributeEngagements)),
});
